import ModelTypeConstants from 'constants/ModelTypeConstants';
import {previewPlugin} from 'notebook/notes/previews/PreviewPluginFactory';

import BasicFolderItemPreview from './BasicFolderItemPreview';

const BASIC_FOLDER_ITEM_PREVIEW_PLUGIN = previewPlugin({
  type: ModelTypeConstants.BASIC_FOLDER_ITEM,
  preview: BasicFolderItemPreview,
});

export default BASIC_FOLDER_ITEM_PREVIEW_PLUGIN;
